<template>
  <div class="fine_plays_approve_page" v-if="numberUnReadFineplayApprove">
    <div v-for="finePlay in finePlays">
      <div v-if="finePlay.can_approve" class="fine_play_item" @click="handleOnClickFinePlay(finePlay.id)">
        <div class="text">
          <span class="date">{{finePlay.created_at | dateFormat}}</span>
          <span class="name">{{finePlay.employee.display_name}}</span>
        </div>
        <div
          class="status"
          :class="{'approval': finePlay.status !== 'preapproval', 'preapproval': finePlay.status === 'preapproval'}"
        >
          {{finePlay.status === 'preapproval' ? '未承認' : '申請中'}}
        </div>
      </div>
    </div>
  </div>
  <div class="fine_plays_approve_page dont_has_fineplays" v-else>
    <p>未承認のファインプレイはありません</p>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import FineplayApi from '../../api/fine-plays'

  export default {
    data () {
      return {
        finePlays: []
      }
    },
    computed: {
      ...mapGetters({
        numberUnReadFineplayApprove: 'masterData/numberUnReadFineplayApprove'
      })
    },
    methods: {
      ...mapActions({
        setNavigatorLinks: 'navigator/setLinks',
        setNavigatorTitle: 'navigator/setTitle'
      }),
      async getFineplayGroup () {
        const loading = this.$loading.show()
        try {
          const res = await FineplayApi.get({active: false})
          this.finePlays = res.data.data
        } catch (e) {
        }
        loading.hide()
      },
      handleOnClickFinePlay (finePlayId) {
        this.$router.push({name: 'finePlayApproves.show', params: {finePlayId}})
      }
    },
    mounted () {
      this.setNavigatorLinks([])
      this.setNavigatorTitle('承認')
      this.getFineplayGroup()
    }
  }
</script>



// WEBPACK FOOTER //
// src/screens/fine-plays-approve/index.vue